import { useQuery } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useListConnectOptions = (autoResponderId?: number) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['connect', 'options', autoResponderId],
    queryFn: () => connectService.listOptions(autoResponderId!),
    enabled: !!autoResponderId
  });

  return { options: data?.data ?? [], isLoading, error, refetch };
};
